










import Vue from 'vue';

export default Vue.extend({

  props: {
    thumbnail: String,
    alt: {
      type: String,
      default: 'Click for larger version',
    },
    altLarge: {
      type: String,
      default: 'Click X to close',
    },
    image: String,
  },

  data() {
    return {
      open: false,
    };
  },

});
